/**
* 请求明细 排重记录
*/
<template>
    <div class="record">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>请求明细</el-breadcrumb-item>
            <el-breadcrumb-item>排重记录</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item label="应用">
                <el-autocomplete size="small" popper-class="my-autocomplete" v-model="formInline.app_name"
                    :fetch-suggestions="paramValueSearch1" @select="handleSelect($event,1)"  @change="handleChange1" placeholder="应用">
                    <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                    <template slot-scope="{ item }">
                        <div class="name">{{ item.value }}</div>
                    </template>
                </el-autocomplete>
            </el-form-item>
            <el-form-item label="渠道">
                <el-autocomplete size="small" popper-class="my-autocomplete" v-model="formInline.channel_name"
                    :fetch-suggestions="paramValueSearch2" @select="handleSelect($event,2)"  @change="handleChange2" placeholder="渠道">
                    <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                    <template slot-scope="{ item }">
                        <div class="name">{{ item.value }}</div>
                    </template>
                </el-autocomplete>
            </el-form-item>
            <el-form-item label="渠道地址">
                <el-input size="small" v-model="formInline.channel_url" placeholder="渠道地址"></el-input>
            </el-form-item>
            <el-form-item label="排重日期">
              <el-date-picker size="small" v-model="formInline.distinct_date" value-format="yyyy-MM-dd" type="date"
                  placeholder="输入排重日期">
              </el-date-picker>
          </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="search" v-auth="'appinfo.list'">搜索
                </el-button>
                <el-button size="small" type="default" icon="el-icon-refresh" @click="reset">重置</el-button>
            </el-form-item>
        </el-form>
        <!--列表-->
        <div class="el-table-con">
            <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                element-loading-text="拼命加载中" style="width: 100%;" @sort-change="sortChange">
                <el-table-column align="center" type="selection" width="60">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="distinct_id" label="排重ID" width="100">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="puton_id" label="投放ID" width="100">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="app_id" label="应用ID" width="100">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="app_name" label="应用名称" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="channel_id" label="渠道ID" width="100">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="channel_name" label="渠道名称" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="channel_url" label="渠道地址" width="160">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="channel_response" label="响应渠道" width="160">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="channel_response_status_name" label="响应状态" width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="app_url" label="应用地址" width="160">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="post_data" label="请求内容" width="160">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="app_response" label="应用响应" width="160">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="channel_request_time" label="渠道时间" width="160">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="app_response_time" label="应用时间" width="160">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="add_time" label="添加时间" width="160">
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </div>
</template>

<script>
    let change = [];
    import {
        distinctrequestList,
        appList,
        channelList
    } from '../../api/basisMG'
    import Pagination from '../../components/Pagination'
    export default {
        inject: ['reload'],
        data() {
            return {
                loading: false, //是显示加载
                formInline: {
                    pageindex: 1,
                    pagesize: 20,
                    app_id: '',
                    app_name: '',
                    channel_id: '',
                    channel_name: '',
                    channel_url: '',
                    distinct_date: '',
                    orderby: ''
                },
                listData: [], //应用数据
                // 分页参数
                pageparm: {
                    currentPage: 1,
                    pageSize: 20,
                    total: 10
                },
                appList: [], //应用列表
                channelList: [], //渠道列表
                time:''
            }
        },
        // 注册组件
        components: {
            Pagination
        },
        /**
         * 数据发生改变
         */

        watch: {},

        /**
         * 创建完毕
         */

        created() { },
        mounted() {
            /*this.getTime();
            if (!this.formInline.distinct_date) {
                this.formInline.distinct_date = this.time;
            }
            var formInline = localStorage.getItem('record')
            if (formInline) {
                this.formInline = JSON.parse(formInline)
            }
            this.getdata(this.formInline)*/
            this.reset();
            this.getappList()
            this.getchannelList()
        },
        /**
         * 里面的方法只有被调用才会执行
         */

        methods: {
            // 获取列表
            getdata(parameter) {
                var that = this;
                that.loading = true;
                distinctrequestList(parameter)
                    .then(res => {
                        that.loading = false
                        if (res.statusCode == 200) {
                            that.listData = res.data.datas
                            // 分页赋值
                            that.pageparm.currentPage = res.data.pageindex
                            that.pageparm.pageSize = res.data.pagesize
                            that.pageparm.total = res.data.rowscount
                        } else {
                            that.$message.error(res.message)
                        }
                    })
            },
            // 获取应用列表
            getappList() {
                var that = this;
                var data = { 'pagesize': '0' }
                appList(data)
                    .then(res => {
                        if (res.statusCode == 200) {
                            res.data.datas.forEach(item => {
                                that.appList.push({
                                    value: item.app_name,
                                    id: item.app_id
                                })
                            });
                        } else {
                            that.$message.error(res.message)
                        }
                    })
            },
            // 获取渠道列表
            getchannelList() {
                var that = this;
                var data = { 'pagesize': '0' }
                channelList(data)
                    .then(res => {
                        if (res.statusCode == 200) {
                            res.data.datas.forEach(item => {
                                that.channelList.push({
                                    value: item.channel_name,
                                    id: item.channel_id
                                })
                            });
                        } else {
                            that.$message.error(res.message)
                        }
                    })
            },
            // 分页插件事件
            callFather(parm) {
                this.formInline.pageindex = parm.currentPage
                this.formInline.pagesize = parm.pageSize
                localStorage.setItem('record', JSON.stringify(this.formInline))
                this.getdata(this.formInline)
            },
            // 排序
            sortChange(column, prop, order) {
                var order = '';
                if (column.order == 'ascending') {
                    order = 'asc'
                } else if (column.order == 'descending') {
                    order = 'desc'
                }
                if (order) {
                    this.formInline.orderby = column.prop + ' ' + order
                    this.search();
                }
            },
            // 搜索事件
            search() {
                this.formInline.pageindex = 1;
                localStorage.setItem('record', JSON.stringify(this.formInline))
                this.getdata(this.formInline)
            },
            // 重置
            reset() {
                this.formInline = {
                    pageindex: 1,
                    pagesize: 20,
                    app_id: '',
                    app_name: '',
                    channel_id: '',
                    channel_name: '',
                    channel_url: '',
                    distinct_date: '',
                    orderby: ''
                }
                this.getTime();
                this.formInline.distinct_date = this.time;

                // 重置清掉本地搜索缓存
                localStorage.removeItem('record')
                this.getdata(this.formInline)
            },
            // 自定义输入下拉框
            paramValueSearch1(queryString, cb) {
                var appList = this.appList;
                var results = queryString ? appList.filter(this.createFilter(queryString)) : appList;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            paramValueSearch2(queryString, cb) {
                var channelList = this.channelList;
                var results = queryString ? channelList.filter(this.createFilter(queryString)) : channelList;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                return (restaurant) => {
                    return restaurant.value.toUpperCase().match(queryString.toUpperCase()) //模糊查询
                    // return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0); // 精准查询
                };
            },
            handleSelect(item,index){
                if(index == 1){
                    this.formInline.app_id = item.id;
                    this.formInline.app_name = item.value;
                }else if(index == 2){
                    this.formInline.channel_id = item.id;
                    this.formInline.channel_name = item.value;
                }
            },
            handleChange1(val){
                if(val == ''){
                    this.formInline.app_id = '';
                    this.formInline.app_name = '';
                    localStorage.setItem('record', JSON.stringify(this.formInline))
                }
            },
            handleChange2(val){
                if(val == ''){
                    this.formInline.channel_id = '';
                    this.formInline.channel_name = '';
                    localStorage.setItem('record', JSON.stringify(this.formInline))
                }
            },
            // 获取当前日期
            getTime() {
                const date = new Date();
                const Y = date.getFullYear();
                const M = date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
                const D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
                this.time = Y + '-' + M + '-' + D;
            },
        }
    }
</script>

<style scoped>
    .user-search {
        margin-top: 20px;
    }

    .userRole {
        width: 100%;
    }
</style>
<style>
    .record .el-table-con {
        height: calc(100vh - 380px) !important;
    }

    .record .page-box {
        text-align: right !important;
    }

    .record .el-table__body-wrapper {
        overflow-y: auto !important;
        max-height: calc(100vh - 460px) !important;
    }

    .record .el-dialog__body {
        max-height: 55vh;
        overflow-y: scroll;
    }

    .record .el-dialog__body::-webkit-scrollbar {
        display: none;
    }
</style>


// WEBPACK FOOTER //
// src/views/detailed/record.vue